$(function () {

//parallax bg
    $(".advantages").on('mousemove touchmove',function(e) {
        var wrapper = $(this);
        if ( $(window).width() > 992 ) {
            parallaxIt(e, wrapper, '.coin-1', -90);
            parallaxIt(e, wrapper, '.coin-2', 25);
            parallaxIt(e, wrapper, '.coin-3', 75);
            parallaxIt(e, wrapper, '.coin-4', -45);
            parallaxIt(e, wrapper, '.coin-5', 45);
        }
    });

    $(".haq").on('mousemove touchmove',function(e) {
        var wrapper = $(this);
        if ( $(window).width() > 992 ) {
            parallaxIt(e, wrapper, '.bg-q-1', -90);
            parallaxIt(e, wrapper, '.bg-q-2', 25);
            parallaxIt(e, wrapper, '.bg-q-3', 75);
            parallaxIt(e, wrapper, '.bg-q-4', -45);
            parallaxIt(e, wrapper, '.bg-q-5', 45);
            parallaxIt(e, wrapper, '.bg-q-6', -15);
            parallaxIt(e, wrapper, '.bg-q-7', 80);
            parallaxIt(e, wrapper, '.bg-q-8', -71);
            parallaxIt(e, wrapper, '.bg-q-9', -60);
        }
    });

    function parallaxIt(e, wrapper, target, movement) {
        var $this = wrapper;
        var relX = e.pageX - $this.offset().left;
        var relY = e.pageY - $this.offset().top;

        TweenMax.to(target, 1.5, {
            x: (relX - $this.width() / 2) / $this.width() * movement * 1.5,
            y: (relY - $this.height() / 2) / $this.height() * movement * 1.5,
            ease: Quad.easeOut
        });
    }


    //laptop logo + border
    if ( $('#laptop-logo').length ) {
        var svg = $('#laptop-logo')[0].contentDocument;
        var logoLt = $(svg).find('#logo-lt')[0];
        var shapeBd1 = $(svg).find('#shape-bd1')[0];
        var shapeBd2 = $(svg).find('#shape-bd2')[0];
        // var color = Math.floor(Math.random() * (300 - 200)) + 200;
        // var color2 = color + Math.floor(Math.random() * (40 - (-40))) + (-40);
        var color = 240;
        var color2 = 280;
        if (svg && logoLt) {
            TweenMax.to(logoLt, 4, {fill: 'hsl(' + Math.random() * 360 + ', 100%, 87%)', repeat: -1, yoyo: true});
            TweenMax.to(shapeBd1, 5, {fill: 'hsl(' + color + ', 100%, 87%)', repeat: -1, yoyo: true});
            TweenMax.to(shapeBd2, 4, {fill: 'hsl(' + color2 + ', 100%, 87%)', repeat: -1, yoyo: true});
        }
    }

//slider say about us
    var arrow_left = '<svg width="20px" height="17px" viewBox="0 0 20 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
        '    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
        '        <g id="01.4-экран" transform="translate(-1666.000000, -242.000000)" fill="#FFFFFF" fill-rule="nonzero">' +
        '            <g id="лево-право" transform="translate(1644.000000, 220.000000)">' +
        '                <g id="left-arrow-copy-2" transform="translate(22.000000, 22.000000)">' +
        '                    <path d="M18.8757724,6.76495935 L18.9069919,6.77178862 L5.52390244,6.77178862 L9.73105691,2.55536585 C9.93707317,2.3495122 10.0500813,2.07065041 10.0500813,1.77796748 C10.0500813,1.48528455 9.93707317,1.20837398 9.73105691,1.00203252 L9.07642276,0.347073171 C8.87056911,0.141219512 8.59626016,0.027398374 8.30373984,0.027398374 C8.01105691,0.027398374 7.73658537,0.140406504 7.53073171,0.346260163 L0.318861789,7.55747967 C0.112195122,7.76414634 -0.00081300813,8.03943089 0,8.33227642 C-0.00081300813,8.62674797 0.112195122,8.90219512 0.318861789,9.10853659 L7.53073171,16.3204065 C7.73658537,16.5260976 8.01089431,16.6392683 8.30373984,16.6392683 C8.59626016,16.6392683 8.87056911,16.525935 9.07642276,16.3204065 L9.73105691,15.6654472 C9.93707317,15.4599187 10.0500813,15.1854472 10.0500813,14.8927642 C10.0500813,14.6002439 9.93707317,14.3402439 9.73105691,14.1345528 L5.47642276,9.89455285 L18.8907317,9.89455285 C19.4934959,9.89455285 20,9.37504065 20,8.77260163 L20,7.84626016 C20,7.24382114 19.4785366,6.76495935 18.8757724,6.76495935 Z" id="Shape"></path>' +
        '                </g>' +
        '            </g>' +
        '        </g>' +
        '    </g>' +
        '</svg>';
    var arrow_right = '<svg width="20px" height="17px" viewBox="0 0 20 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
        '    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
        '        <g id="01.4-экран" transform="translate(-1736.000000, -242.000000)" fill="#FFFFFF" fill-rule="nonzero">' +
        '            <g id="лево-право" transform="translate(1644.000000, 220.000000)">' +
        '                <g id="left-arrow-copy" transform="translate(102.000000, 30.500000) scale(-1, 1) translate(-102.000000, -30.500000) translate(92.000000, 22.000000)">' +
        '                    <path d="M18.8757724,6.76495935 L18.9069919,6.77178862 L5.52390244,6.77178862 L9.73105691,2.55536585 C9.93707317,2.3495122 10.0500813,2.07065041 10.0500813,1.77796748 C10.0500813,1.48528455 9.93707317,1.20837398 9.73105691,1.00203252 L9.07642276,0.347073171 C8.87056911,0.141219512 8.59626016,0.027398374 8.30373984,0.027398374 C8.01105691,0.027398374 7.73658537,0.140406504 7.53073171,0.346260163 L0.318861789,7.55747967 C0.112195122,7.76414634 -0.00081300813,8.03943089 0,8.33227642 C-0.00081300813,8.62674797 0.112195122,8.90219512 0.318861789,9.10853659 L7.53073171,16.3204065 C7.73658537,16.5260976 8.01089431,16.6392683 8.30373984,16.6392683 C8.59626016,16.6392683 8.87056911,16.525935 9.07642276,16.3204065 L9.73105691,15.6654472 C9.93707317,15.4599187 10.0500813,15.1854472 10.0500813,14.8927642 C10.0500813,14.6002439 9.93707317,14.3402439 9.73105691,14.1345528 L5.47642276,9.89455285 L18.8907317,9.89455285 C19.4934959,9.89455285 20,9.37504065 20,8.77260163 L20,7.84626016 C20,7.24382114 19.4785366,6.76495935 18.8757724,6.76495935 Z" id="Shape"></path>' +
        '                </g>' +
        '            </g>' +
        '        </g>' +
        '    </g>' +
        '</svg>';

    var rewievSl = $(".reviews-slider");
    rewievSl.addClass("owl-carousel");

    rewievSl.owlCarousel({
        // margin: 20,
        navText: [arrow_left, arrow_right],
        loop: true,
        autoplay: true,
        autoplayTimeout: 7000,
        responsive: {
            0: {
                nav: false,
                dots: true,
                items: 1
            },
            769: {
                items: 2,
                nav: true,
                dots: false
            },
            1500: {
                items: 3,
                nav: true,
                dots: false
            }
        }
    });

    // var advSl = $('.advantages-list');
    // var haqSl = $('haq-grid');
    var sl768 = $('.advantages-list, .haq-grid');
    sl768.addClass("owl-carousel");

    //callback before init sl
    // advSl.on('initialize.owl.carousel', function(event) {});

    function initSl768() {
        sl768.owlCarousel({
            items: 1,
            nav: false,
            dots: true,
            autoplay: true,
            autoplayTimeout: 7000,
            loop: true
        });
    }
    function destroySl768() {
        //v1
        sl768.trigger('destroy.owl.carousel');
        sl768.html(sl768.find('.owl-stage-outer').html()).removeClass('owl-loaded');
        //v2
        // sl768.trigger('destroy.owl.carousel');
        // sl768.find('.owl-stage-outer').children().unwrap();
        // sl768.removeClass("owl-center owl-loaded owl-text-select-on");
    }
    if ( $(window).outerWidth() <= 768 ) {
        initSl768();
    }
    var oneResSl768 = $(window).outerWidth() <= 768;
    $(window).resize(function () {
        if ( $(window).outerWidth() > 768 && oneResSl768 ) {
            destroySl768();
            oneResSl768 = false;
        }
        if ( $(window).outerWidth() <= 768 && !oneResSl768 ) {
            initSl768();
            oneResSl768 = true;
        }
    });

});